import {Outlet} from 'react-router-dom';

const StatLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
}

export default StatLayout;